import { useMemo } from 'react';

import { ApiCreateScanNote } from '@kaiizen/kai-pro-api';

import { useAuth } from '../../../useAuth';

import { SyncRecordBase, useSyncModel } from '../persistence';

export interface ScanNoteSyncRecord extends SyncRecordBase {
  scanPartId: string;
  noteData: ApiCreateScanNote & { id: string };
}

export const useScanNoteSyncModel = () => {
  const { userId } = useAuth();
  const model = useSyncModel<ScanNoteSyncRecord>('scanNote');

  return useMemo(() => ({
    ...model,
    addScanNoteToSync: async (scanId: string, scanPartId: string, noteData: ApiCreateScanNote & { id: string }) => {
      if (!userId) throw new Error('userId required');
      try {
        await model.put({
          _id: noteData.id,
          userId,
          scanId,
          scanPartId,
          noteData,
          isSynced: false,
          isSyncing: false,
          isFailed: false,
        });
      } catch (error) {
        // A note that isn't queued never reaches the server, so the writer must hear about it.
        console.error('Failed to add scan note to sync', error, { userId, scanId, scanPartId, noteData });
        throw error;
      }
    },
  }), [model, userId]);
};
